import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/addressBook',
    component: LAYOUT,
    redirect: '/addressBook/college',
    meta: { title: '校友通讯录', showNavPanel: true },
    children: [
      {
        path: 'college',
        name: '院系',
        component: () => import('@/views/addressBook/college.vue'),
        meta: { title: '院系', showNavPanelBorder: true },
      },
      {
        path: 'city',
        name: '同城',
        component: () => import('@/views/addressBook/city.vue'),
        meta: { title: '同城', showNavPanelBorder: true },
      },
      {
        path: 'industry',
        name: '同行',
        component: () => import('@/views/addressBook/industry.vue'),
        meta: { title: '同行', showNavPanelBorder: true },
      },
      {
        path: 'university',
        name: '同院',
        component: () => import('@/views/addressBook/university.vue'),
        meta: { title: '同院', showNavPanelBorder: true },
      },
      {
        path: 'year',
        name: '同级',
        component: () => import('@/views/addressBook/year.vue'),
        meta: { title: '同级', showNavPanelBorder: true },
      },
      {
        path: 'peopleDetail/:id',
        name: '校友详情',
        component: () => import('@/views/addressBook/peopleDetail.vue'),
        meta: { title: '校友详情', hide: true },
      },
    ],
  },
]
